import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DescriptorDataService } from "../service/descriptor-data.service";
@Component({
  selector: "app-descriptor-data-list",
  templateUrl: "./descriptor-data-list.component.html",
  styleUrls: ["./descriptor-data-list.component.css"],
})
export class DescriptorDataListComponent implements OnInit {
  @Input() id: any;
  constructor(private descriptorDataService: DescriptorDataService) {}

  descriptorDataListObs$!: Observable<any>;
  ngOnInit(): void {
    this.fnListObservable(this.id);
  }

  fnListObservable(id: string) {
    this.descriptorDataListObs$ = this.descriptorDataService
      .getAll()
      .pipe(map((data) => data.filter((_x) => _x.variety_id == id)));
  }
}
